import { MatDatepickerIntl } from '@angular/material/datepicker';
import { Injectable } from '@angular/core';

/**
 * Etichette italiane del datepicker. Nomi di mesi e giorni arrivano dal
 * DateAdapter (vedi il locale in app.config.ts); qui stanno le stringhe fisse
 * di Material, che restano in inglese anche a locale impostato: sono quasi
 * tutte etichette per screen reader, piu' il testo del pulsante di chiusura.
 * Stesso schema di CustomPaginatorIntl.
 */
@Injectable({
  providedIn: 'root', // This makes it available application-wide
})
export class CustomDatepickerIntl extends MatDatepickerIntl {
  override calendarLabel = 'Calendario';
  override openCalendarLabel = 'Apri il calendario';
  override closeCalendarLabel = 'Chiudi il calendario';
  override prevMonthLabel = 'Mese precedente';
  override nextMonthLabel = 'Mese successivo';
  override prevYearLabel = 'Anno precedente';
  override nextYearLabel = 'Anno successivo';
  override prevMultiYearLabel = 'Precedenti 24 anni';
  override nextMultiYearLabel = 'Successivi 24 anni';
  override switchToMonthViewLabel = 'Scegli il giorno';
  override switchToMultiYearViewLabel = 'Scegli mese e anno';
  override comparisonDateLabel = 'Intervallo di confronto';

  /** Intervallo di anni nella vista multi-anno (visibile, non solo per screen reader) */
  override formatYearRangeLabel = (start: string, end: string): string =>
    `da ${start} a ${end}`;

  constructor() {
    super();

    // Trigger the change detection
    this.changes.next();
  }
}
